<template>
    <div class="dashboard-header">
    <div style="background: url(borderbg.png) 50% 100% no-repeat;padding-bottom: 5px;
margin-bottom: 25px;">
        <h1 style="border-left: 5px solid #ff1516; padding-left: 30px;">Home</h1>
        </div>
        <header>
            <dashboard-info-box />
        </header>
    </div>
</template>

<script>
import DashboardInfoBox from '../DashboardInfoBox/DashboardInfoBox.vue';

export default {
    name: 'DashboardHeader',

    components: { DashboardInfoBox },
};
</script>

<style lang="scss">
@import 'style';

</style>
